import wrapper from 'wrapper';
import Gallery from './components/gallery/gallery-rx';
import { FadeTransition } from './components/gallery/transition';

new Gallery(wrapper.select('#gallery'), {}, FadeTransition());

wrapper.markPageAsLoaded();
